const OP_CONNECTION_STATUS = {
  CONNECTED: 'connected',
  DISCONNECTED: 'disconnected',
  UNREACHABLE: 'unreachable',
} as const;

export default OP_CONNECTION_STATUS;
